<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>App广告页配置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      
      <div class="page-actions">
         <create-banner @refresh="refreshList"></create-banner>
        <!-- <el-select
          :value="query.type"
          @change="handleQueryChange('type', $event)"
          placeholder="请选择"
        >
          <el-option
            v-for="item in bannerTypes"
            :key="item.type"
            :label="item.message"
            :value="item.type"
          ></el-option>
        </el-select> -->
        <el-select
          :value="query.language"
          @change="handleQueryChange('language', $event)"
          placeholder="请选择"
        >
          <el-option
            v-for="item in languageList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <!-- <el-select
          :value="query.platform"
          @change="handleQueryChange('platform', $event)"
          placeholder="请选择"
        >
          <el-option
            v-for="item in platformTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
         -->
       
      </div>
      <!-- <el-tabs v-model="area" @tab-click="handleAreaChange" type="card">
        <el-tab-pane
          v-for="item in tradeAreaCopy"
          :label="item"
          :name="item"
          :key="item"
        ></el-tab-pane>
      </el-tabs> -->
      <banner-list @refresh="refreshList"></banner-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import BannerList from './components/list';
import CreateBanner from './components/create';
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  name: 'BannerSetting',
  data () {
    return {
       area: '启动页',
      tradeAreaCopy:['启动页','广告页','金刚区']
    }
  },
  components: {
    BannerList,
    CreateBanner
  },
  computed: {
    ...mapState('addAdvertisePageSetting', [
      'platformTypeList',
      'languageList',
      'query',
      'bannerTypes'
    ])
  },
  methods: {
    ...mapActions('addAdvertisePageSetting', ['list', 'getbannerType','listData']),
    ...mapMutations('addAdvertisePageSetting', ['changeQuery']),
    refreshList() {
    //   this.list(this.query);
     this.listData()
    },
     handleAreaChange(tab) {
      this.pair = '';
      this.area = tab.name;
      },
    handleQueryChange(type, value) {
      this.changeQuery({
        ...this.query,
        [type]: value
      });
      // this.refreshList();
    }
  },
  created() {
    // this.list(this.query);
    this.listData()
    this.getbannerType();
  }
};
</script>

<style lang="less" scoped></style>
